// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1e-7";
export var adjustableWidthBorderHeld = "_1e-8";
export var arrow = "_1e-3";
export var arrowButton = "_1e-4";
export var headerCell = "_1e-0";
export var help = "_1e-2";
export var icon = "_1e-1";
export var iconWrapper = "_1e-6";
export var noBorder = "_1e-b";
export var nonAdjustableWidthBorder = "_1e-9";
export var nonAdjustableWidthBorderHeld = "_1e-a";
export var textButton = "_1e-5";